import { z } from 'zod';
import { TypeOfAPIError, TypeOfAPIResponse } from '@ninja/api-client';
import { APIFactoryOptions, factory } from '../../../config';

export const requestSchema = z.object({
	planCode: z.string(),
	planId: z.number(),
	benefitSummaryData: z.array(z.object({ benefitSummaryEN: z.string(), benefitSummaryAR: z.string() })),
});

const responseSchema = z.any();

const postImportBenefitsSummary = (options: APIFactoryOptions) =>
	factory(options).createAPIDefinition({
		url: '/admin/benefit/import/benefitsummary',
		method: 'POST',
		responseSchema,
		requestSchema,
	});

export type PostImportBenefitsSummaryRequest = z.infer<typeof requestSchema>;

export type PostImportBenefitsSummaryResponse = TypeOfAPIResponse<ReturnType<typeof postImportBenefitsSummary>>;

export type PostImportBenefitsSummaryError = TypeOfAPIError<ReturnType<typeof postImportBenefitsSummary>>;

export default postImportBenefitsSummary;
